import { Link } from "react-router-dom";
import { usePageMeta } from "../../hooks/usePageMeta";
import { REVIEWS } from "../../mocks/reviews";
import Breadcrumb from "../../components/feature/Breadcrumb";

const VALUES = [
  { icon: "ri-eye-line", title: "看得清", desc: "把纷繁复杂的娱乐资讯整理得井井有条，让你用最少的时间看懂大家在聊什么。" },
  { icon: "ri-time-line", title: "跟得上", desc: "按“今日速递”的节奏滚动跟进首播、档期与热搜变化，不错过每一次新鲜围观。" },
  { icon: "ri-scales-3-line", title: "拎得清", desc: "以整理公开资讯为主，不传播未经验证的不实信息，也不对任何作品或艺人作主观评判。" },
];

const PRINCIPLES = [
  "以公开资讯为依据，来源可追溯、表述克制；",
  "栏目与标签清晰，帮助读者按兴趣快速找到内容；",
  "尊重作品与创作者，拒绝标题党和恶意断章取义；",
  "保持理性围观，倡导友善、文明的讨论氛围。",
];

const CONTACT = [
  { icon: "ri-mail-line", label: "内容合作 / 投稿", value: "hello@chigua17.example.com" },
  { icon: "ri-chat-smile-3-line", label: "纠错反馈", value: "tips@chigua17.example.com" },
  { icon: "ri-time-line", label: "服务时间", value: "工作日 9:00 - 21:00，随缘秒回" },
];

export default function About() {
  usePageMeta({
    title: "关于我们 · 品牌介绍与内容理念",
    description:
      "了解吃瓜17：一个聚焦影视、综艺、音乐与热点话题的娱乐资讯聚合平台。这里介绍我们的品牌定位、发展理念与内容原则，也欢迎你把建议告诉我们。",
    keywords: "吃瓜17,关于我们,品牌介绍,内容理念,网站定位",
    path: "/about",
    schema: [
      {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        name: "关于我们 · 吃瓜17",
        url: "https://xttkax.cn/about",
        inLanguage: "zh-CN",
        mainEntity: {
          "@type": "Organization",
          name: "吃瓜17",
          url: "https://xttkax.cn/",
          description: "聚焦影视、综艺、音乐与热点话题的娱乐资讯聚合平台。",
          email: "hello@chigua17.example.com",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [{ "@type": "ListItem", position: 1, name: "今日首页", item: "https://xttkax.cn/" }, { "@type": "ListItem", position: 2, name: "关于我们" }],
      },
    ],
  });

  return (
    <div className="pt-16 md:pt-[72px]">
      <div className="bg-secondary-100 py-10 md:py-16">
        <div className="mx-auto max-w-[1200px] px-4 md:px-6">
          <Breadcrumb items={[{ label: "今日首页", to: "/" }, { label: "关于我们" }]} />
          <div className="mt-6 flex flex-col items-start gap-6 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-4 py-1.5 text-sm font-semibold text-background-50">
                <i className="ri-megaphone-line" aria-hidden="true"></i>About Us
              </span>
              <h1 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-5xl">关于吃瓜17</h1>
              <p className="mt-4 max-w-2xl text-lg text-foreground-700">把今天值得围观的新鲜事，整理得又快又明白。</p>
            </div>
            <div className="flex shrink-0 gap-3">
              {[{ v: "5+", k: "内容栏目" }, { v: "24h", k: "滚动跟进" }].map((s) => (
                <div key={s.k} className="rounded-2xl bg-background-50 px-6 py-4 text-center">
                  <p className="font-heading text-2xl font-bold text-primary-600">{s.v}</p>
                  <p className="mt-1 text-xs text-foreground-500">{s.k}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          <section>
            <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950">
              <i className="ri-open-arm-line text-primary-500" aria-hidden="true"></i>品牌故事
            </h2>
            <p className="mt-4 leading-8 text-foreground-700">
              娱乐信息更新得太快，追剧、追综艺、看热搜，常常让人应接不暇。吃瓜17 想做的，就是替你把这些新鲜内容整理成一份清晰、及时、不掺水的“速递”。
            </p>
            <p className="mt-4 leading-8 text-foreground-700">
              我们关注影视、综艺、音乐、明星动态与热点话题，按栏目分类呈现，让不同兴趣的读者都能快速找到自己想看的那块“瓜田”。无论是剧集上新、名场面盘点，还是热搜复盘与热梗科普，我们都尽量用客观、好懂的方式讲清楚。
            </p>
            <div className="mt-6 rounded-2xl border-l-4 border-accent-500 bg-accent-50 px-5 py-4 text-foreground-700">
              “吃瓜”是一场快乐的围观，但我们也始终记得：热闹之外，还有真实需要被尊重。
            </div>
          </section>

          <section>
            <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950">
              <i className="ri-compass-3-line text-primary-500" aria-hidden="true"></i>网站定位
            </h2>
            <p className="mt-4 leading-8 text-foreground-700">
              吃瓜17 定位为面向普通用户的<span className="font-semibold text-foreground-950">娱乐资讯聚合与讨论平台</span>。我们不做八卦炒作的“发酵者”，而是做公共娱乐信息的“整理者”——帮你过滤噪音、标注重点，把大家正在围观的话题掰开揉碎讲清楚。
            </p>
            <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {VALUES.map((v) => (
                <div key={v.title} className="rounded-2xl border border-background-200/70 bg-background-50 p-5">
                  <i className={`${v.icon} text-2xl text-primary-500`} aria-hidden="true"></i>
                  <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">{v.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              ))}
            </div>
          </section>
        </div>

        <section className="mt-12 grid grid-cols-1 gap-8 rounded-3xl bg-background-100 p-6 md:p-10 lg:grid-cols-2">
          <div>
            <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950">
              <i className="ri-shield-check-line text-accent-600" aria-hidden="true"></i>我们的内容原则
            </h2>
            <ul className="mt-5 space-y-3">
              {PRINCIPLES.map((p, i) => (
                <li key={i} className="flex items-start gap-3 text-foreground-700">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-500 text-xs text-background-50">
                    <i className="ri-check-line" aria-hidden="true"></i>
                  </span>
                  {p}
                </li>
              ))}
            </ul>
          </div>
          <div className="rounded-2xl border border-background-200/70 bg-background-50 p-6">
            <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
              <i className="ri-message-3-line text-primary-500" aria-hidden="true"></i>联系我们
            </h2>
            <ul className="mt-5 space-y-4">
              {CONTACT.map((c) => (
                <li key={c.label} className="flex items-center gap-3">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-primary-600">
                    <i className={c.icon} aria-hidden="true"></i>
                  </span>
                  <div>
                    <p className="text-xs text-foreground-500">{c.label}</p>
                    <p className="text-sm font-medium text-foreground-900">{c.value}</p>
                  </div>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-xs text-foreground-500">如有投稿、纠错或合作意向，欢迎来信，我们会在核实后及时回复。</p>
          </div>
        </section>

        <section className="mt-12">
          <div className="mb-6 flex flex-col items-center text-center">
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">Readers</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">读者这样说</h2>
          </div>
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
            {REVIEWS.map((r) => (
              <figure key={r.name} className="rounded-2xl border border-background-200/70 bg-background-50 p-5">
                <i className="ri-double-quotes-l text-2xl text-accent-500" aria-hidden="true"></i>
                <blockquote className="mt-2 text-sm leading-relaxed text-foreground-700">{r.text}</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-200 text-sm font-semibold text-foreground-700">{r.name.slice(0, 1)}</span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{r.name}</p>
                    <p className="text-xs text-foreground-500">{r.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </section>

        <section className="mt-12 text-center">
          <Link to="/news" className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600">
            <i className="ri-article-line" aria-hidden="true"></i>去看看今日速递
          </Link>
        </section>
      </div>
    </div>
  );
}